import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import playlistService from "../../services/PlaylistService.js";

import Button from "../Nano/Buttons/Button.js";
import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import Input from "../Nano/Input.js";

import { ReactComponent as Playlist } from "../Global/Icons/playlist.svg";

const multiple = nota.global.multiple;

const EditPlaylistModalStyle = styled.div`
  width: 350px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }

  .formWrapper {
    .formContainer {
      margin-bottom: ${multiple + "px"};
    }
    p {
      margin-bottom: 2px;
    }
    .dropDownContainer {
      width: 100%;
    }
    .inputWrapper {
      width: 100%;
      div {
        margin: 0;
      }
    }
    textarea {
      font-family: ${nota.font};
      width: 100%;
      height: 150px;
      overflow: auto;
      border: 1px solid ${(props) => (props.error ? nota.color.main.mTwo : nota.color.neutral.NeuTwo)};
      padding: 10px;
      width: 100%;
      font-size: 12px;
      color: ${nota.color.neutral.NeuOne};
      resize: none;
      &::placeholder {
        color: ${nota.color.neutral.NeuTwo};
      }
    }
  }

  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
    margin: auto;

    .btnsContainer {
      flex-direction: column;
      .buttonWrapper {
        order: 1;
      }
      .simpleButtonWrapper {
        order: 2;
        margin-top: ${multiple + "px"};
      }
    }
  }
`;

class EditPlaylistModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      playlist: this.props.playlist,
      NameError: false,
    };
  };

  componentDidUpdate(prevProps, prevState) {}

  onNameChange = (value) => {
    let immutableObj = { ...this.state.playlist };
    immutableObj.name = value;
    this.setState({ playlist: immutableObj });
  };

  onDescriptionChange = (value) => {
    let immutableObj = { ...this.state.playlist };
    immutableObj.description = value;
    this.setState({ playlist: immutableObj });
  };

  saveSearch = () => {
    if (this.state.playlist.name && this.state.playlist.name.trim() != "") {
      this.setState({ NameError: false });
      playlistService
        .savePlaylist(this.state.playlist)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          /*Trigger playlistsChange Event */
          window.dispatchEvent(new Event("playlistsChange"));
          if (this.props.nextAction) this.props.nextAction();
        });
    } else {
      this.setState({ NameError: true });
    }
  };

  cancelSaveSearch = () => {
    if (this.props.cancelAction) this.props.cancelAction();
  };

  render() {
    return (
      <EditPlaylistModalStyle>
        <NanoFlex className="headerModal" justifyContent="flex-start">
          <Playlist />
          <Type.h3>
            <b>{this.translation.playlists.editPlaylist}</b>
          </Type.h3>
        </NanoFlex>
        <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
          <NanoFlex className="modalWrapper" flexDirection={"column"}>
            <NanoFlex className="formWrapper" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <NanoFlex className="formContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <Type.p>{this.translation.playlists.name}</Type.p>
                <div className="inputWrapper">
                  <Input defaultValue={this.state.playlist.name} title="" placeholder={this.translation.playlists.namePlaceholder} error={this.state.NameError} onChangeAction={this.onNameChange} />
                </div>
              </NanoFlex>

              <NanoFlex className="formContainer" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <Type.p>{this.translation.playlists.description}</Type.p>
                <textarea
                  value={this.state.playlist.description}
                  placeholder={this.translation.playlists.descriptionPlaceholder}
                  onChange={(e) => {
                    this.onDescriptionChange(e.target.value);
                  }}></textarea>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
            <Button label={this.translation.geral.cancel} simple clickAction={this.cancelSaveSearch} />
            <Button label={this.translation.geral.confirm} clickAction={this.saveSearch} />
          </NanoFlex>
        </NanoFlex>
      </EditPlaylistModalStyle>
    );
  }
}

// Set default props
EditPlaylistModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default EditPlaylistModal;

/*
Doc
import EditPlaylistModal from '../../Micro/EditPlaylistModal.js';

<EditPlaylistModal
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
